import {useGlobal} from "../../contexts/GlobalContext";
import "../../data/css/About.scss"

export default function AboutProject({img, techstack, projectName, href, special=[]}) {
    const {isMobile} = useGlobal()
    return (
        <div className={"col-xl-4 col-sm-6 col-xs-12 py-2 d-flex align-items-stretch m-0 about-project-div"}>
        <div className={"card w-100  about-project"}>
            <div className={"text-center "}> <h6 className={"d-inline pr-2"}>{projectName}</h6>
                <div className={!isMobile && "d-inline"}>
                {techstack.map(Technology =>
                    <div className={"icons p-0 d-inline"}><Technology size={"1.5rem"}/></div>
                )}

                {special.map(Technology =>
                    <h4 className={"icons p-1 d-inline"}>{Technology}</h4>
                )}
                </div>
            </div>
            <a target={"_blank"} rel="noreferrer" href={href} className={"about-img my-auto mx-auto w-100"}>
                <img className={"img-fluid rounded"} src={img} alt={""}/>
            </a>
        </div>
        </div>
    );
}


